export { default } from "./AddressesCard-container";
